import { Component, Input } from "@angular/core";

@Component({
	selector: "stages-split-button",
	templateUrl: "./splitbutton.component.html",
	styleUrls: ["splitbutton.component.scss"],
})
export class SplitbuttonComponent {
	@Input()
	items?: MenuItem[];
}
